// extracted by mini-css-extract-plugin
export var container = "index-module--container--GSYDG";
export var paragraph = "index-module--paragraph--E3wS4";
export var title = "index-module--title--uoF-O";